export enum ClientNameEnum {
  Signup = 'signup',
  SignupService = 'signup-service',
  PostBindService = 'post-bind-service',
  PostBindWorker = 'post-bind-worker',
  PaymentService = 'payment-service',
  RefiEngine = 'refi-engine',
  ShoppingService = 'shopping-service',
  OrderService = 'order-service',
  Partner = 'partner',
  Quoting = 'quoting',
  QuotingService = 'quoting-service',
  Headless = 'headless',
  HeadlessService = 'headless-service',
  GarageCRM = 'garage-crm',
}
